import { MESSAGE_TYPES } from '@/constants';

const constructMessage = (title, message, counter, type) => {
  return {
    timestamp: new Date().getTime(),
    type,
    title,
    message,
    counter: counter + 1,
  };
};

const GET_API_VERSION = (state, { apiVersion }) => {
  state.apiVersion = apiVersion;
};

const SET_MESSAGE_ERROR = (state, { title, message }) => {
  state.message = {
    ...constructMessage(title, message, state.message.counter, MESSAGE_TYPES.ERROR),
  };
};

const SET_MESSAGE_SUCCESS = (state, { title, message }) => {
  state.message = {
    ...constructMessage(title, message, state.message.counter, MESSAGE_TYPES.SUCCESS),
  };
};

const SET_MESSAGE_MODAL = (state, { title, message }) => {
  state.message = {
    ...constructMessage(title, message, state.message.counter, MESSAGE_TYPES.MODAL),
  };
};

const SET_ADMIN_SELECTED_OFFICE = (state, { office }) => {
  state.adminSelectedOffice = office;
};

const SET_ADMIN_SELECTED_COMPANY = (state, { company }) => {
  state.adminSelectedCompany = company;
};

export default {
  SET_MESSAGE_ERROR,
  SET_MESSAGE_SUCCESS,
  SET_MESSAGE_MODAL,
  SET_ADMIN_SELECTED_OFFICE,
  SET_ADMIN_SELECTED_COMPANY,
  GET_API_VERSION,
};



// WEBPACK FOOTER //
// ./store/modules/global/mutations.js